import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { GLOBAL_MANY_IDS_SEP } from '@chiroup/core/constants/globals';
import { Test } from '@chiroup/core/types/Test.type';
import { CustomizationListItem } from '../components/clinical-skills/CustomizationListItem.type';

const testService = () => {
  type TestsQueryParams = {
    ids?: string;
    patientId?: string;
  };

  const list = async (
    clinicId = -1,
    ids?: number[],
    patientId?: string
  ): Promise<{
    data: CustomizationListItem[];
    skip: number;
  }> => {
    const queryParams: TestsQueryParams = {};
    if (ids && ids.length > 0) queryParams.ids = ids.join(',');
    if (patientId) queryParams.patientId = patientId;

    return ChiroUpAPI.get('api', `/${clinicId}/tests`, { queryParams });
  };

  const add = async (clinicId: number, body: Partial<Test>): Promise<Test> => {
    return ChiroUpAPI.post('api', `/${clinicId}/tests`, {
      body,
    });
  };

  const findOne = async (clinicId = -1, id: string): Promise<Test> => {
    return ChiroUpAPI.get('api', `/${clinicId}/tests/${id}`, {});
  };

  const getMany = async (clinicId = -1, ids: number[], patientId?: string): Promise<Test> => {
    const queryParams: { patientId?: string } = {};

    if (patientId) {
      queryParams.patientId = patientId;
    }

    return ChiroUpAPI.get('api', `/${clinicId}/tests/${ids.join(GLOBAL_MANY_IDS_SEP)}`, {
      queryParams,
    });
  };

  const save = async (clinicId = -1, id: string | number, body: Partial<Test>): Promise<Test> => {
    return await ChiroUpAPI.patch('api', `/${clinicId}/tests/${id}`, {
      body,
    });
  };

  return {
    list,
    add,
    findOne,
    getMany,
    save,
  };
};

export default testService();
